module.exports = __webpack_public_path__ + "static/media/students.14a51b2b.png";